<template>
<div class="col-12 md:col-2 ">




<div class=" show_on_mobile">

<Fieldset :legend="name" :toggleable="true" :collapsed="true">


<ItemSidebarContent 
:brand="brand" 
:project="project" 
:flow="flow"  
:flows="flows" 
:questionlist="questionlist" 
:educationpack="educationpack" 
:section="section" 
:questioncount="questioncount" 
:sectioncount="sectioncount" 
:suppliercount="suppliercount" 
:projectcount="projectcount" 
:flowcount="flowcount" 
:finishedcount="finishedcount"  
:awaitingcount="awaitingcount"  
></ItemSidebarContent>


</Fieldset>
</div>





<div class="content_card_content sticky_panel hide_on_mobile">
<h3 class=" text-primary mt-0 mb-1">{{$filters.sidebartextadjust( name)}}</h3>
<template v-if="flow_type">
<Tag 
class="custom-chip mb-1" 
:value="flowtype" 
:style="'background-color:'+flowtypecolor"
/>
</template>
<hr>

<ItemSidebarContent 
:brand="brand" 
:project="project" 
:flow="flow" 
:flows="flows" 
:questionlist="questionlist" 
:educationpack="educationpack" 
:section="section" 
:questioncount="questioncount" 
:sectioncount="sectioncount" 
:suppliercount="suppliercount" 
:projectcount="projectcount" 
:flowcount="flowcount" 
:finishedcount="finishedcount"  
:awaitingcount="awaitingcount"  
:is_active="is_active"  
></ItemSidebarContent>



<slot name="addition"></slot>







</div>




</div>




</template>

<script>
import ItemSidebarContent from "./ItemSidebarContent"
export default {
  props:["name","brand","project","flow","flows","questionlist","educationpack","section","questioncount","sectioncount","suppliercount","projectcount","flowcount","finishedcount","awaitingcount","is_active","flow_type"],
  name: 'ItemSidebar',
  components:{ItemSidebarContent},
  data () {
    return {

    }
  },
  computed:{
    flowtypecolor()
    {
      if(this.flow_type=="self_evaluation")
      {
        return "#ff6600"
      }
      if(this.flow_type=="education")
      {
        return "#3b82f6"
      }
      if(this.flow_type=="verification")
      {
        return "#7e2f8d"
      }
      if(this.flow_type=="audit")
      {
        return "#352f8d"
      }
    },
    flowtype()
    {
      if(this.flow_type=="self_evaluation")
      {
        return this.$store.state.languages.lang_phrases.self_evaluation
      }
      if(this.flow_type=="education")
      {
        return  this.$store.state.languages.lang_phrases.egitim
      }
      if(this.flow_type=="verification")
      {
        return  this.$store.state.languages.lang_phrases.verification
      }
      if(this.flow_type=="audit")
      {
        return  this.$store.state.languages.lang_phrases.audit
      }
    },
  }
}
</script>

<style lang="css" scoped>
</style>